module.exports = __webpack_public_path__ + "media/veracruz/ConvocatoriaTorneoAjedrez-c5bb889d.jpg";